import React from "react";
import { Box, Grid2 } from "@mui/material";
import { HistoricalQuotesChart } from "@components";
import { LoadingPlaceHolder } from "@rentablo/components";
import { FundamentalsCard } from "../FundamentalsCard";
import { RanksAndRisks } from "../RanksAndRisks";
import { Props as FundamentalsByIsinProps } from "../../FundamentalsPageByIsin";
import { GainLossStatisticsLoader } from "../../../watchlists/details/GainLossStatisticsLoader";
import { useDividendsPerYear } from "../../hooks/useDividendsPerYear";
import { DividendsChart } from "../DividendsChart/DividendsChart";
import { TopHoldings } from "../TopHoldings";

export const FundFundamentalsByIsin = ({
  isin,
  watchlistEntryId,
  quoteProvider,
  tickerSymbol,
}: FundamentalsByIsinProps) => {
  const { data: dividends, isLoading: isDividendsLoading } =
    useDividendsPerYear(isin);

  const areDividendsPresent = dividends && dividends?.length > 0;

  if (isDividendsLoading) {
    return (
      <Box mt={6}>
        <LoadingPlaceHolder />
      </Box>
    );
  }

  return (
    <Grid2 container spacing={4} width="100%" mt={5}>
      {watchlistEntryId && (
        <FundamentalsCard>
          <GainLossStatisticsLoader watchlistEntryId={watchlistEntryId} />
        </FundamentalsCard>
      )}

      {areDividendsPresent && (
        <FundamentalsCard hideFor={["kpmg-germany"]}>
          <DividendsChart isin={isin} currency="EUR" />
        </FundamentalsCard>
      )}

      <FundamentalsCard hideFor={["kpmg-germany"]}>
        <HistoricalQuotesChart
          quoteProvider={quoteProvider}
          tickerSymbol={tickerSymbol}
        />
      </FundamentalsCard>

      <FundamentalsCard hideFor={["kpmg-germany"]}>
        <RanksAndRisks isin={isin} />
      </FundamentalsCard>

      <FundamentalsCard showFor={["kpmg-germany"]}>
        <TopHoldings isin={isin} />
      </FundamentalsCard>
    </Grid2>
  );
};
